<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="rakamTanimlama"> Rakam Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="rakamGuncelle"> Rakam Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="rakamListesi"> Rakam listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="rakamDetay"> Rakam Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="rakamDurumGuncelle"> Rakam Durum Güncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import rakamService from '../../../WSProvider/RakamService';
    import notification from '../../../notification'
    let base64 = require('base64_js');
    let userData = "";
    export default {
        name: "RakamDetay",
        methods: {
            rakamTanimlama() {
                let dil = [{
                    dil: "en",
                    rakamAdi: "fbdb"
                }];
                rakamService.rakamTanimlama("vdfbdf", "", 10,dil);
            },
            rakamDurumGuncelle() {
                rakamService.rakamDurumGuncelle(2, 0);
            },
            rakamDetay() {
                rakamService.rakamDetay(4);
            },
            rakamGuncelle() {
                rakamService.rakamGuncelle(3, "zsfsd", "ghnfg", 20);
            },
            rakamListesi() {
                rakamService.rakamListesi(1, 0,10);
            },

        }
    }
</script>

<style scoped>

</style>